var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, Complex, ChildProperty } from '@syncfusion/ej2-base';
import { SmithchartFont } from '../utils/utils';
export class LegendTitle extends ChildProperty {
}
__decorate([
    Property(true)
], LegendTitle.prototype, "visible", void 0);
__decorate([
    Property('')
], LegendTitle.prototype, "text", void 0);
__decorate([
    Property('')
], LegendTitle.prototype, "description", void 0);
__decorate([
    Property('Center')
], LegendTitle.prototype, "textAlignment", void 0);
__decorate([
    Complex({ fontFamily: null, size: null, fontStyle: null, fontWeight: null, color: null }, SmithchartFont)
], LegendTitle.prototype, "textStyle", void 0);
export class LegendLocation extends ChildProperty {
}
__decorate([
    Property(0)
], LegendLocation.prototype, "x", void 0);
__decorate([
    Property(0)
], LegendLocation.prototype, "y", void 0);
export class LegendItemStyleBorder extends ChildProperty {
}
__decorate([
    Property(1)
], LegendItemStyleBorder.prototype, "width", void 0);
__decorate([
    Property(null)
], LegendItemStyleBorder.prototype, "color", void 0);
export class LegendItemStyle extends ChildProperty {
}
__decorate([
    Property(10)
], LegendItemStyle.prototype, "width", void 0);
__decorate([
    Property(10)
], LegendItemStyle.prototype, "height", void 0);
__decorate([
    Complex({}, LegendItemStyleBorder)
], LegendItemStyle.prototype, "border", void 0);
export class LegendBorder extends ChildProperty {
}
__decorate([
    Property(1)
], LegendBorder.prototype, "width", void 0);
__decorate([
    Property(null)
], LegendBorder.prototype, "color", void 0);
export class SmithchartLegendSettings extends ChildProperty {
}
__decorate([
    Property(false)
], SmithchartLegendSettings.prototype, "visible", void 0);
__decorate([
    Property('bottom')
], SmithchartLegendSettings.prototype, "position", void 0);
__decorate([
    Property('Center')
], SmithchartLegendSettings.prototype, "alignment", void 0);
__decorate([
    Property(null)
], SmithchartLegendSettings.prototype, "width", void 0);
__decorate([
    Property(null)
], SmithchartLegendSettings.prototype, "height", void 0);
__decorate([
    Property('circle')
], SmithchartLegendSettings.prototype, "shape", void 0);
__decorate([
    Property(null)
], SmithchartLegendSettings.prototype, "rowCount", void 0);
__decorate([
    Property(null)
], SmithchartLegendSettings.prototype, "columnCount", void 0);
__decorate([
    Property(8)
], SmithchartLegendSettings.prototype, "itemPadding", void 0);
__decorate([
    Property(5)
], SmithchartLegendSettings.prototype, "shapePadding", void 0);
__decorate([
    Property('')
], SmithchartLegendSettings.prototype, "description", void 0);
__decorate([
    Property(true)
], SmithchartLegendSettings.prototype, "toggleVisibility", void 0);
__decorate([
    Complex({}, LegendTitle)
], SmithchartLegendSettings.prototype, "title", void 0);
__decorate([
    Complex({}, LegendLocation)
], SmithchartLegendSettings.prototype, "location", void 0);
__decorate([
    Complex({}, LegendItemStyle)
], SmithchartLegendSettings.prototype, "itemStyle", void 0);
__decorate([
    Complex({}, LegendBorder)
], SmithchartLegendSettings.prototype, "border", void 0);
__decorate([
    Complex({ fontFamily: null, size: null, fontStyle: null, fontWeight: null, color: null }, SmithchartFont)
], SmithchartLegendSettings.prototype, "textStyle", void 0);
